import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { equalValidator } from '../custom-validators/equal.validator';
import { checkForFormFieldErrors } from '../helpers/form-errors';
import { CreatePasswordComponent } from '../passwords/create-password.component';
import { MessageDisplayModel } from '../message/messageDisplay.model';

@Component({
  selector: 'expired-password',
  templateUrl: './expired-password.component.html'
})
export class ExpiredPasswordComponent extends CreatePasswordComponent implements OnInit {

  @Input() public messageDisplay: MessageDisplayModel;
  // @Input() isWaiting: boolean;
  @Output() public formSubmit: EventEmitter<string> = new EventEmitter();

  public passwordForm: FormGroup;
  public hasPasswordFormBeenSubmitted: boolean = false;

  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.buildResetPasswordForm();
  }

  private buildResetPasswordForm(): void {
    this.passwordForm = this.fb.group({
      passwordGroup: this.fb.group({
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword
      }, { validator: equalValidator })
    });
  }

  public onPasswordFormSubmit() {
    this.hasPasswordFormBeenSubmitted = true;
    if (this.passwordForm.valid) {
      this.formSubmit.emit(this.passwordForm.value);
    }
  }

  public shouldShowUpdatePasswordFormError(field) {
    return checkForFormFieldErrors(field, this.hasPasswordFormBeenSubmitted);
  }

  public shouldShowExpiredPasswordConfirmFormError(field) {
    return (field.invalid || this.passwordForm.hasError('equal', ['passwordGroup'])) && this.hasPasswordFormBeenSubmitted;
  }
}
